import { useState } from "react";
import {
  Paper,
  Typography,

  Divider,
  Button,
} from "@mui/material";
import { FieldValues, useForm, useWatch } from "react-hook-form";

import FormConfiguration from "./formInputs";
import FormPreview from "./formView";
import { saveConsentFormMaster } from "../../../../EMR/components/ConsenForms/services";
import usePopup from "@hooks/usePopup";
import { useMutation } from "react-query";
import { FormBuilderProvider, useFormBuilder } from "../formMasterContext";


const FormMasterContent = () => {
  const { showSnackbar } = usePopup()
  const[refetchlistofForms,setRefetchlistofForms]=useState(false)
  const { control, handleSubmit, setValue, reset } = useForm<FieldValues>({
    defaultValues: {
      templateImage: "",
      fields: [],
      existingForm: null,
      formName: "",
      formLanguage: null,
      selectedForm: null,
      direction: null,
      orientation: null,
      fieldType: null,
      keyName: null,
      activeTool: null,
      selectedFieldId: null,
    },
  });
  const watchAllFields = useWatch({ control });
const [resetKey, setResetKey] = useState(0);
  const { mutate: saveFormMaster } = useMutation(saveConsentFormMaster, {
    onSuccess: (result: any) => {

      showSnackbar({
        message: result.responseMessage,
        open: true,
        variant: "success",
        duration: 2000,
      });
      setRefetchlistofForms(true)
      reset();
      setResetKey(prev => prev + 1);
      setFormData({
        templateMetadata: {
          templateImage: "",
          fields: [],
        },
      });
    },
    onError: (error: any) => {
      showSnackbar({
        message: error?.response?.data?.responseMessage || "Something went wrong!",
        open: true,
        variant: "info",
        duration: 2500,
      });
    }
  });

  const onSubmit = async (data: any) => {
    const rawImage = data.templateImage || formData?.templateMetadata?.templateImage || "";
    const finalTemplateImage = rawImage.includes(",") ? rawImage.split(",")[1] : rawImage;

    const payload = {
      id: data.existingForm?.templateId ?? null, // pass templateId if editing an existing form
      templateMetadata: {
        orientation: data.orientation,
        marginTop: 20,
        marginBottom: 20,

        fields: (data.fields || data || []).map((field: any) => ({
          id: field.id,
          keyName: field.keyName ?? "",
          type: field.type,
          value: field.value ?? "",
          xMM: field.xMM,
          yMM: field.yMM,
          widthMM: field.widthMM,
          pageIndex: field.pageIndex,
          heightMM: field.heightMM,
          options: field.options ?? [],
          direction: field.direction ?? data.direction?.value ?? null,
        })),

        selectedFieldId: data.selectedFieldId ?? null,
        selectedForm: data.selectedForm ?? null,
        formName: data.formName ?? null,
        language: data.formLanguage ?? null,
        templateImage: finalTemplateImage
      }
    };

    console.log("🔥 FINAL PAYLOAD:", payload);
    saveFormMaster(payload);
  };

  const [getPrintHtml, setGetPrintHtml] = useState<() => string>(() => () => "");
  console.log("TYPE:", typeof getPrintHtml);
  const { formData, setFormData } = useFormBuilder();
  return (
    <div className="bg-[#f8f9fa] h-[calc(100vh-4rem)] overflow-hidden p-2">
      <form onSubmit={handleSubmit(onSubmit)} className="h-full">
        <Paper elevation={0} className="flex flex-col h-full border border-gray-200 rounded-xl overflow-hidden">


          <div className="flex justify-between items-center p-4 bg-white shrink-0">
            <Typography variant="h6" className="font-bold text-slate-800">
              Form Master
            </Typography>

            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit(onSubmit)}
            >
              Save
            </Button>
          </div>

          <Divider />

          <div className="flex flex-1 overflow-hidden">
            <div className="grid grid-cols-12 w-full h-full">
              <div className="col-span-12 md:col-span-5 lg:col-span-3 h-full overflow-y-auto p-4 border-r bg-white">
                <FormConfiguration control={control} setValue={setValue} refetchlistofForms={refetchlistofForms} resetKey={resetKey} />
              </div>
              <div className="col-span-12 md:col-span-7 lg:col-span-9  overflow-y-auto bg-slate-100 p-8 flex justify-center items-start">
                <FormPreview
                  watchData={watchAllFields}
                  control={control}
                  setValue={setValue}
                  onPrintReady={setGetPrintHtml}
                />
              </div>

            </div>
          </div>
        </Paper>
      </form>
    </div>
  );
};

const FormMaster = () => {
  return (
    <FormBuilderProvider>
      <FormMasterContent />
    </FormBuilderProvider>
  );
};

export default FormMaster;